import { AUTH_TOKEN_KEY, REFRESH_TOKEN_KEY } from '@/config/constants'

export const AUTH_USER_CHANGED_EVENT = 'auth:user-changed'

function emitAuthUserChanged(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(AUTH_USER_CHANGED_EVENT))
}

/**
 * Get authentication token from localStorage
 */
export function getAuthToken(): string | null {
  if (typeof window === 'undefined') return null
  return localStorage.getItem(AUTH_TOKEN_KEY)
}

/**
 * Set authentication token in localStorage
 */
export function setAuthToken(token: string): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(AUTH_TOKEN_KEY, token)
}

/**
 * Get refresh token from localStorage
 */
export function getRefreshToken(): string | null {
  if (typeof window === 'undefined') return null
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

/**
 * Set refresh token in localStorage
 */
export function setRefreshToken(token: string): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(REFRESH_TOKEN_KEY, token)
}

/**
 * Remove authentication token from localStorage
 */
export function removeAuthToken(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem(AUTH_TOKEN_KEY)
}

/**
 * Remove refresh token from localStorage
 */
export function removeRefreshToken(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem(REFRESH_TOKEN_KEY)
}

/**
 * Store current user in localStorage (after login)
 */
export function setUser(user: { id: string; name: string; email: string; role: string; avatar?: string | null }): void {
  if (typeof window === 'undefined') return
  localStorage.setItem('user', JSON.stringify(user))
  emitAuthUserChanged()
}

/**
 * Remove current user from localStorage (e.g. on logout)
 */
export function removeUser(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem('user')
  emitAuthUserChanged()
}

/**
 * Clear all auth data (token + user). Use on logout.
 */
export function clearAuth(): void {
  removeAuthToken()
  removeRefreshToken()
  removeUser()
}

/**
 * Get current user from localStorage
 */
export function getUser(): { id: string; name: string; email: string; role: string; avatar?: string | null } | null {
  if (typeof window === 'undefined') return null
  const raw = localStorage.getItem('user')
  if (!raw) return null
  try {
    return JSON.parse(raw) as { id: string; name: string; email: string; role: string; avatar?: string | null }
  } catch {
    return null
  }
}
